import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import Table from "../../../../../../common/components/table";
import { useAppDispatch } from "../../../../../../hooks/hooks";
import { selectMembershipTypesListItems } from "../../../../../../redux/membership-types/selector";
import { membershipTypes } from "../../../../../../redux/membership-types/action";
import { useNavigate } from "react-router-dom";
import PageLoader from "../../../../../../components/PageLoader";
import { selectListItems } from "../../../../../../redux/library/selector";


const ManagementMembershipTypes = () => {
	const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const [pageData, setPageData] = useState(1)
  const libraryData = useSelector(selectListItems)
    const membershipTypeItems = useSelector(selectMembershipTypesListItems)
    const [
        columnDefs,
        setColumnDefs
      ] = useState({});
      const createColumnDefs: any = () => {
        setColumnDefs([
          {
            field: 'Sl',
            sortable: false,
            filter: false,
            isSortLabel: true,
            headerName: 'Sl',
            cellRenderer (params: any) {
              return parseInt(
                params.node.id,
                10
              ) + 1;
            },
          },
          { field: 'Name', headerName: 'Name'},
          { field: 'MembershipName', headerName: 'Membership Name' },
          { field: 'TypeId', headerName: 'Membeership Type', cellRenderer: 'libraryRendererComponent', cellRendererParams: { library: libraryData?.result?.MembershipTypes } },
          { field: 'CreatedOnUtc', headerName: 'Created On', isDateValueFormat: true },
          { field: 'ModifiedOnUtc', headerName: 'Modified On', isDateValueFormat: true }
      
        ]);
      }
      const handleAdd=()=>{
        navigate(`${0}`)
      }
      const handleEdit=(data: any)=>{
        
        navigate(`${data?.Id}`)
      }
      const handleDelete=(data: any)=>{
        dispatch(membershipTypes.delete({
          url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/membership-management/membership-types/delete`,
          entity: 'membershipTypes',
          jsonData: {
              Records: [
                  {
                      Id: data?.Id
                  }
              ]
          }
      })).then(() => {
        dispatch(membershipTypes.list({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/membership-management/membership-types/list`,entity:'membershipTypes',jsonData:{
           "PageNumber": pageData,
              "PageSize": 10,
              "SortField": "Id",
              "SortOrder": "desc",}
          }));
      });
      }  
      const fetchMembershipTypes=()=>{

        dispatch(membershipTypes.list({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/membership-management/membership-types/list`,entity:'membershipTypes',jsonData:{
           "PageNumber": pageData,
              "PageSize": 10,
              "SortField": "Id",
              "SortOrder": "desc",}
          }));
       
      }
	useEffect(() => {
        createColumnDefs()
        fetchMembershipTypes()
	}, [pageData])

  const additionButtons: any = [
    {
      name: 'Add MembershipTypes',
      callback: () => handleAdd(),
    }
  ];
	return (
    <>
    {membershipTypeItems?.isLoading ? 
    <PageLoader />
: 
		<Table columnData={columnDefs} rowData={membershipTypeItems?.result?.items} setPageData={setPageData}
    paginationData={membershipTypeItems?.result?.pagination} onEdit={handleEdit} onDelete={handleDelete} additionButtons={additionButtons} headingName="MembershipTypes"  />
  }
  </> 
     
	);
};

export default ManagementMembershipTypes;


